module.exports = __webpack_public_path__ + "img/logo.305e0f3b.png";